import React, { useEffect, useState } from 'react';
import { Container, Paper, Table, TableBody, TableCell, TableHead, TableRow, Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../api/axiosConfig';

const ProgramaList = () => {
  const [programas, setProgramas] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/programas/').then(res => setProgramas(res.data));
  }, []);

  return (
    <Container>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h5">Programas</Typography>
        <Button variant="contained" onClick={() => navigate('/programas/nuevo')}>Nuevo Programa</Button>
      </Box>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Código</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Sector</TableCell>
              <TableCell>Activo</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {programas.map(prog => (
              <TableRow key={prog.id_programa}>
                <TableCell>{prog.codigo}</TableCell>
                <TableCell>{prog.descripcion}</TableCell>
                <TableCell>{prog.sector?.descripcion}</TableCell>
                <TableCell>{prog.activo ? 'Sí' : 'No'}</TableCell>
                <TableCell>
                  <Button size="small" variant="outlined" onClick={() => navigate(`/programas/${prog.id_programa}`)}>
                    Editar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};

export default ProgramaList;